import type { FC } from 'react';
import { Flex, Section, Typography } from '@ui';
import { useTranslation } from 'react-i18next';
import { BookingsTable } from '@/components/BookingsTable/BookingsTable';
import { EventsCarousel } from '@/components/EventsCarousel/EventsCarousel';
import { GenericPageSectionWrapper } from '@/components/GenericPageSectionWrapper/GenericPageSectionWrapper';
import styles from './BookingsEventsSection.module.css';

export const BookingsEventsSection: FC = () => {
    const { t } = useTranslation();

    return (
        <GenericPageSectionWrapper title={t('Events_Title')}>
            <Flex gap={80}>
                <Flex flex="0 0 calc(40% - 40px)" vertical gap={48} className={styles.bookingsContainer}>
                    <Typography.Heading level={3} color="textPrimary">{t('Events_Bookings_Title')}</Typography.Heading>
                    <Section block>
                        <BookingsTable />
                    </Section>
                </Flex>
                <Flex flex="0 0 calc(60% - 40px)" vertical gap={48} className={styles.carouselContainer}>
                    <Typography.Heading level={3} color="textPrimary">{t('Events_Events_Title')}</Typography.Heading>
                    <EventsCarousel />
                </Flex>
            </Flex>
        </GenericPageSectionWrapper>
    );
};
